import RelatoriosService from "@/services/RelatoriosService";

export const relatorios = {
  namespaced: true,
  state: {
    relatorios: {},
  },
  actions: {
    getRelatorios({ commit }, payload) {
      return RelatoriosService.GetRelatorios(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postRelatorios({ commit }, payload) {
      return RelatoriosService.PostRelatorios(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putRelatorios({ commit }, payload) {
      return RelatoriosService.PutRelatorios(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteRelatorios({ commit }, payload) {
      return RelatoriosService.DeleteRelatorios(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getRelatoriosOData({ commit }, payload) {
      return RelatoriosService.GetRelatoriosOData(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },

    downloadRelatorio({ commit }, payload) {
      return RelatoriosService.DownloadRelatorio(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    getRelatoriosUsuario({ commit }, payload) {
      return RelatoriosService.GetRelatoriosUsuario(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    executarRelatorio({ commit }, payload) {
      return RelatoriosService.ExecutarRelatorio(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    carregarRelatorio({ commit }, payload) {
      return RelatoriosService.CarregarRelatorio(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    getRelatorio({ commit }, payload) {
      return RelatoriosService.GetRelatorio(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default relatorios;
